import jwt_decode from 'jwt-decode'
import { useContext, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import sha1 from 'sha1'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { LoginContext } from '../context/loginContext'
import * as loginService from '../servicios/loginService'

const Login = () => {
  const [searchParams] = useSearchParams()
  const { setLoginData } = useContext(LoginContext)
  const navigate = useNavigate()

  const processLogin = async (tokenProp) => {
    try {
      const decoded = jwt_decode(tokenProp)

      const { data } = await loginService.validarUsuario({
        token: decoded.token
      })
      const verified = data.resultado

      if (verified) {
        setLoginData(decoded)
        navigate('/Publicaciones')
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al validar el usuario.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  const processLoginDev = async () => {
    try {
      // TODO: SEGURIDAD - SHA1 es inseguro para passwords
      // El backend actualmente requiere SHA1. Se debe migrar a bcrypt/argon2
      // y mover el hashing al backend. Issue: [crear issue en GitHub]
      const { data } = await loginService.loguearUsuario({
        tipo: 'E',
        usuario: import.meta.env.VITE_USUARIO,
        empid: import.meta.env.VITE_EMPID,
        password: sha1(import.meta.env.VITE_PASS) // nosemgrep: javascript.lang.security.insecure-hash-algorithm-sha1
      })

      if (data.login) {
        setLoginData(data)
        navigate('/Publicaciones')
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al loguearse.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  useEffect(() => {
    // Get token from URL parameters
    const token = searchParams.get('token')
    if (token) {
      try {
        processLogin(token)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Login failed:', error)
      }
    } else {
      processLoginDev()
    }
  }, [searchParams])

  return <></>
}

export default Login
